let _ = t => t,
  _t,
  _t2,
  _t3,
  _t4,
  _t5,
  _t6;
import styled from 'styled-components';
import { colors, fontSize, fontWeights } from '@ovpn-ui/styles';
import { Logout } from '@ovpn-ui/icons';
import { Text } from '@ovpn-ui/core';
export const Container = styled.div(_t || (_t = _`
    display: flex;
    flex-direction: column;

    padding: 0 8px;

    border: 1px solid ${0};
    border-radius: 4px;
`), colors.neutralBorder);
export const Section = styled.div(_t2 || (_t2 = _`
    display: flex;
    flex-direction: column;

    padding: 8px 0;

    border-bottom: 1px solid ${0};

    &:first-of-type {
        padding: 16px 16px;
        row-gap: 8px;
    }

    &:last-of-type {
        border: none;
    }
`), colors.neutralLight);
export const Username = styled(Text)(_t3 || (_t3 = _`
    margin: 0;

    color: ${0};
    font-weight: ${0};
    font-size: ${0};
    line-height: ${0};

    white-space: wrap;
    word-wrap: break-word;
`), colors.neutralTextBody, fontWeights.medium, fontSize.small, fontSize.xMedium);
export const Description = styled(Text)(_t4 || (_t4 = _`
    margin: 0;

    color: ${0};
    font-size: ${0};
    line-height: ${0};
`), colors.neutralTextSubtitle, fontSize.small, fontSize.xMedium);
export const Name = styled.span(_t5 || (_t5 = _`
    overflow: hidden;

    white-space: nowrap;
    text-overflow: ellipsis;
`));
export const LogoutIcon = styled(Logout)(_t6 || (_t6 = _`
    color: ${0};
`), colors.neutralTextSection);